import React, { useEffect, useState } from "react";

const APP_SCHEME = "examos://auth";

// Google sign-in landing page for the Android app: hands the session_id back to the app.
export default function MobileAuth() {
  const [target, setTarget] = useState("");
  const sessionId = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    const url = `${APP_SCHEME}?session_id=${encodeURIComponent(sessionId)}`;
    setTarget(url);
    window.location.replace(url);
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6" data-testid="mobile-auth-page">
      <div className="text-center max-w-sm">
        <div className="font-display text-2xl font-bold mb-2">
          {sessionId ? "Returning to the app…" : "Sign-in link is invalid"}
        </div>
        <div className="text-zinc-500 text-sm mb-6">
          {sessionId ? "If nothing happens, tap the button below." : "Go back to the ExamOS app and try Google sign-in again."}
        </div>
        {target && (
          <a href={target} className="inline-block bg-zinc-900 text-white px-6 py-3 text-sm font-medium hover:bg-zinc-800 transition-colors" data-testid="mobile-auth-open-app-btn">
            Open ExamOS app
          </a>
        )}
      </div>
    </div>
  );
}
